/**
 * Theme styles for ::import syntax — single-line directive,
 * L0 pretty widget, L2 mark decoration.
 */

import { EditorView } from "@codemirror/view";
import {
    CM_MONO_FONT_FAMILY,
    accentIconStyles,
    accentMutedColor,
    accentText,
    directiveLineStyles,
    directivePrettyStyles,
} from "../shared/theme-helpers";

const IMPORT_ACCENT = "--cm-import-accent";
const META_ACCENT = "--cm-meta-accent";
const REF_ASSET = "--cm-ref-content";

export const importTheme = EditorView.baseTheme({
    /* L2: Import directive text */
    ".cm-magic-import-head": {
        color: `var(${IMPORT_ACCENT})`,
        fontWeight: "500",
        letterSpacing: "0.02em",
    },
    ".cm-magic-import-close": {
        color: `var(${IMPORT_ACCENT})`,
        fontWeight: "500",
        letterSpacing: "0.02em",
    },
    /* Background for import line */
    ".cm-magic-import-line": directiveLineStyles(IMPORT_ACCENT, 6, 30),
    ".cm-magic-import-active .cm-magic-btn-group": {
        opacity: "1",
        maxWidth: "120px",
        pointerEvents: "auto",
    },
    /* L0: Pretty import widget */
    ".cm-magic-import-pretty": directivePrettyStyles(IMPORT_ACCENT, {
        gap: "5px",
    }),
    ".cm-magic-import-pretty-icon": accentIconStyles(IMPORT_ACCENT),
    ".cm-magic-import-pretty-ns": accentText(IMPORT_ACCENT, {
        fontWeight: "600",
        letterSpacing: "0.01em",
    }),
    ".cm-magic-import-pretty-arrow": {
        color: accentMutedColor(IMPORT_ACCENT, 60),
        fontSize: "12px",
    },
    ".cm-magic-import-pretty-source": {
        color: `var(${IMPORT_ACCENT})`,
        fontWeight: "400",
        fontFamily: CM_MONO_FONT_FAMILY,
        fontSize: "12px",
    },
    ".cm-magic-import-pretty-source-ref": {
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        minWidth: "0",
        color: `var(${REF_ASSET})`,
        fontFamily: "inherit",
    },
    ".cm-magic-import-pretty-source-ref .cm-magic-ref-pretty-icon": {
        ...accentIconStyles(REF_ASSET),
        flexShrink: "0",
    },
    ".cm-magic-import-pretty-source-ref .cm-magic-ref-pretty-id, .cm-magic-import-pretty-source-ref .cm-magic-ref-pretty-path, .cm-magic-import-pretty-source-ref .cm-magic-ref-pretty-sep":
        {
            color: `var(${REF_ASSET})`,
            fontSize: "12px",
        },
    ".cm-magic-import-pretty-source-ref .cm-magic-ref-pretty-path": {
        fontFamily: CM_MONO_FONT_FAMILY,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    ".cm-magic-import-pretty-source-ref .cm-magic-ref-pretty-sep": {
        opacity: "0.5",
    },
    ".cm-magic-import-pretty-badge": {
        color: `var(${IMPORT_ACCENT})`,
        fontSize: "11px",
        opacity: "0.7",
        fontFamily: CM_MONO_FONT_FAMILY,
    },
    ".cm-magic-import-pretty-rename": {
        color: `var(${META_ACCENT})`,
        fontSize: "11px",
        opacity: "0.7",
        fontFamily: CM_MONO_FONT_FAMILY,
        fontStyle: "italic",
    },
});
